import './App.css'
import React, { useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { useAuth } from './contexts/AuthContext'
import Login from './pages/public/Login'
import Menu from './components/Menu'
import Dashboard from './pages/private/Dashboard'
import Configuracoes from './pages/private/Configuracoes'
import NovosProjetos from './pages/private/NovosProjetos'
import Integradores from './pages/private/Integradores'
import Users from './pages/private/Users'
import Reports from './pages/private/Reports'
import Projetos from './pages/private/Projetos'
import Orcamentos from './pages/private/Orcamentos'

function PrivateRoute({ children, ...rest }) {
  const { isAuthenticated, booting } = useAuth()
  if (booting) return null
  return (
    <Route
      {...rest}
      render={() => (isAuthenticated ? children : <Redirect to="/login" />)}
    />
  )
}

function PublicRoute({ children, ...rest }) {
  const { isAuthenticated, booting } = useAuth()
  if (booting) return null
  return (
    <Route
      {...rest}
      render={() => (isAuthenticated ? <Redirect to="/integradores" /> : children)}
    />
  )
}

function App() {
  const { user, signOut, isAuthenticated, booting } = useAuth()
  const allowedRoles = ['ADMINISTRADOR', 'GERENTE']
  const isAdmin = allowedRoles.includes(user?.role)
  const [open, setOpen] = useState(true)

  return (
    <div className="App">
      {isAuthenticated && !booting && (
        <Route
          path="/:id2"
          render={() => (
            <Menu
              user={user}
              logoff={() => signOut()}
              abrir={(a) => setOpen(a)}
            />
          )}
        />
      )}

      <div
        style={{
          paddingLeft:
            window.innerWidth < 675 ? '0rem' : isAuthenticated ? (open ? '15rem' : '4.5rem') : '0rem',
          paddingTop: window.innerWidth < 675 && '0.75rem',
          transition: '0.25s',
        }}
      >
        <Switch>
          <PublicRoute path="/login">
            <Login />
          </PublicRoute>

          <PrivateRoute exact path="/dashboard">
            {isAdmin ? <Dashboard user={user} /> : <Redirect to="/integradores" />}
          </PrivateRoute>

          <PrivateRoute exact path="/projetos">
            {isAdmin ? <NovosProjetos user={user} /> : <Redirect to="/integradores" />}
          </PrivateRoute>

          <PrivateRoute exact path="/integradores">
            <Integradores user={user} />
          </PrivateRoute>

          <PrivateRoute exact path="/integradores/projetos/:id">
            <Projetos user={user} />
          </PrivateRoute>

          <PrivateRoute exact path="/usuarios">
            {isAdmin ? <Users user={user} /> : <Redirect to="/integradores" />}
          </PrivateRoute>

          <PrivateRoute exact path="/configuracoes">
            <Configuracoes user={user} />
          </PrivateRoute>

          <PrivateRoute exact path="/relatorios">
            {isAdmin ? <Reports user={user} /> : <Redirect to="/integradores" />}
          </PrivateRoute>

          <PrivateRoute exact path="/orcamentos">
            {isAdmin ? <Orcamentos user={user} /> : <Redirect to="/integradores" />}
          </PrivateRoute>

          <Route path="*">
            <Redirect to={isAuthenticated ? '/integradores' : '/login'} />
          </Route>
        </Switch>
      </div>

      <ToastContainer
        style={{ zIndex: '9999999' }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default App
